// extracted by mini-css-extract-plugin
export default {"aboutMe":"About_aboutMe__Xle3h","firstLetter":"About_firstLetter__LCQ5+"};